/**
 * Modos do cardápio ↔ role de cada um. Espelha `ROLES_POR_MODO` do backend
 * (`backend/src/lib/roles.ts`). Cada modo é um módulo próprio da empresa e
 * gateia a aba correspondente na tela de configuração do backoffice.
 */
export const MODOS_CARDAPIO = {
  delivery: { role: 'ROLE_CARDAPIO_DELIVERY', nome: 'Delivery' },
  comandaMesa: { role: 'ROLE_CARDAPIO_COMANDA_MESA', nome: 'Comanda/Mesa' },
  totem: { role: 'ROLE_CARDAPIO_TOTEM', nome: 'Totem' },
  totemCheckout: { role: 'ROLE_CARDAPIO_TOTEM_CHECKOUT', nome: 'Totem Checkout' },
  tablet: { role: 'ROLE_CARDAPIO_TABLET', nome: 'Tablet (na mesa)' },
  vitrine: { role: 'ROLE_CARDAPIO_VITRINE', nome: 'Vitrine' },
} as const;

export type ModoCardapio = keyof typeof MODOS_CARDAPIO;

/** Quais modos a empresa contratou (retornado por `/api/admin/me`). */
export type AcessoModos = Record<ModoCardapio, boolean>;
